import { Pipe, PipeTransform } from '@angular/core';

import { clienteAnaliseFinanceiraStatuses as statuses } from '../cliente-analise-financeira-status';

@Pipe({
    name: 'clienteAnaliseFinanceiraStatusBadge'
})
export class ClienteAnaliseFinanceiraStatusBadgePipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = statuses.findIndex(status => status.id === value);
        if (index > -1) {
            return statuses[index].badge;
        }
        return '';
    }
}
